import { Html } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { CompetitionRegistrationPageController } from "../controllers/CompetitionRegistrationPageController";

const TournamentDetailsSection = () => {
  const controller = CompetitionRegistrationPageController.use();
  const { tournament, competition, partnerCode } = controller.state;

  if (!tournament || !competition) {
    return null;
  }

  return (
    <>
      <h2 className="text-lg font-medium">{tournament.name}</h2>
      <p className="mb-4 text-gray-600">
        {competition.entry_type === "doubles" ? "Doubles" : "Singles"} Competition
      </p>

      <Html html={competition.description || ""} />

      {partnerCode && (
        <div className="mt-4 rounded-md bg-blue-50 p-4 text-blue-800">
          You are joining as a doubles partner
        </div>
      )}

      {competition.entry_type === "doubles" && !partnerCode && (
        <p className="mt-6 rounded bg-white p-3 text-sm text-gray-600">
          This competition requires a doubles partner. After you register, you'll receive a link to share with
          another player.
        </p>
      )}
    </>
  );
};

export default ApplicationView(TournamentDetailsSection);
